import { request } from '../../../../common/utility/fetch'
import configuration from '../../../../configuration'
import { AppThunk, RootState } from '../../../store'
import { selectedWorkoutFavoriteUpdate } from '../SelectedWorkout'
import { workoutsFavoriteUpdate } from '../Workouts'
import {
  Favorite,
  favoriteAdded,
  favoriteFailure,
  FavoriteParams,
  favoritePending,
  favoriteRemoved,
} from '.'

const baseUrl = configuration.onlinePlatformApi

export const toggleFavorite = async (
  args: FavoriteParams,
  authToken?: string,
): Promise<Favorite> => {
  const endpoint = '/workout-library/workouts/' + args.workoutId + '/favorite'
  const method = 'POST'
  const response = await request({ baseUrl, endpoint, method, authToken })
  return response
}

export const favorite =
  (args: FavoriteParams): AppThunk =>
  async (dispatch, getState) => {
    dispatch(
      favoritePending({
        workoutId: args.workoutId,
        isLoading: true,
        error: '',
      }),
    )
    const state = getState() as RootState
    const pathname = state.router?.location?.pathname
    try {
      const response = await toggleFavorite(args, state.auth?.user?.auth_token)
      const result = await response.json()
      if (response.ok) {
        if (!result.deleted) {
          dispatch(
            favoriteAdded({
              workoutId: result.workoutId,
              isLoading: false,
              error: '',
            }),
          )
        } else {
          dispatch(favoriteRemoved(result.workoutId))
        }
        pathname === '/'
          ? dispatch(workoutsFavoriteUpdate(result.workoutId))
          : dispatch(selectedWorkoutFavoriteUpdate())
      } else {
        throw new Error(result)
      }
    } catch (error: any) {
      dispatch(
        favoriteFailure({
          workoutId: args.workoutId,
          isLoading: false,
          error: 'An unknown error occured',
        }),
      )
    }
  }
